// update specific custom field

import getJSON from '@api/api_helper';

// key in this context is the uuid of the CF value entry
const mutateUrl = (customFieldValueKey): string => `/api/v4/custom_field_values/${customFieldValueKey}`;

export const updateCustomFieldValue = ({ key, value }: { key: string; value: string }, params = {}): Promise<any> => {
  const url = mutateUrl(key);
  const appendedOptions = {
    body: {
      data: {
        attributes: {
          value
        }
      }
    },
    method: 'PUT',
    params
  };
  return getJSON(url, appendedOptions);
};

export const deleteCustomFieldValue = (key: string, params = {}): Promise<Response> => {
  const url = mutateUrl(key);
  const appendedOptions = {
    method: 'DELETE',
    params
  };
  return getJSON(url, appendedOptions);
};
